import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetMonthlyServiceChargesRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getMonthlyServiceCharges = async (
  instance: AxiosInstance,
  params: DefaultApiGetMonthlyServiceChargesRequest
) => {
  return await userApiDefaultApiFactory(instance).getMonthlyServiceCharges(
    params
  )
}

// Do Not Remove this line ===@import api client===
